import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "../../../../components/ui/command";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../components/ui/popover";
import { Button } from "../../../../components/ui/button";
import { ChevronsUpDown } from "lucide-react";
import { cn } from "../../../../helpers/cn";
import { useState } from "react";
import { Controller } from "react-hook-form";

export function StateMileageSelect({ control, errors, stateOptions }) {
  const [open, setOpen] = useState(false);

  return (
    <Controller
      control={control}
      name="state"
      render={({ field }) => {
        const selected = stateOptions.find((c) => c.value === field.value);

        return (
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <Button
                type="button"
                variant="outline"
                role="combobox"
                aria-expanded={open}
                className={cn(
                  "w-full justify-between",
                  errors.state && "border-red-500 focus:ring-red-500"
                )}
              >
                {selected ? selected.label : "Select state mileage"}
                <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[300px] p-0">
              <Command>
                <CommandInput placeholder="Search states..." />
                <CommandList
                  className="max-h-60 overflow-y-auto overscroll-contain"
                  onWheel={(e) => {
                    e.stopPropagation();
                    const el = e.currentTarget;
                    el.scrollBy({ top: e.deltaY, behavior: "auto" });
                  }}
                >
                  <CommandEmpty>No state found.</CommandEmpty>
                  <CommandGroup>
                    {stateOptions.map((opt) => (
                      <CommandItem
                        key={opt.value}
                        value={opt.label}
                        onSelect={() => {
                          field.onChange(opt.value);
                          setOpen(false);
                        }}
                      >
                        {opt.label}
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </CommandList>
              </Command>
            </PopoverContent>
          </Popover>
        );
      }}
    />
  );
}
